import { defaultLocale } from 'constants/locale';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import { i18n } from 'utils/setupTranslations';

export const LocalizedBrowserRouter = ({
    basename,
    children,
}: {
    basename: string;
    children: React.ReactNode;
}) => {
    const { isGuestUser } = useAuthentication();
    const { locale } = i18n;

    const shouldLocalizedBasename = isGuestUser && locale !== defaultLocale;

    const localizedBasename = shouldLocalizedBasename
        ? `${basename}/${locale}`
        : basename;

    return (
        <BrowserRouter basename={localizedBasename}>{children}</BrowserRouter>
    );
};
